import angular from 'angular';
import { actions } from '../../../../state';

export default angular
  .module('app.validators.async-email', [])
  .directive('asyncEmail', validator);

function validator($q, updStore) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attrs, ctrl) {
    let inviteToken = attrs.inviteToken;

    ctrl.$asyncValidators.asyncEmail = (modelValue, viewValue) => {
      let email = modelValue || viewValue;
      let params = { email };
      if (inviteToken) {
        params.ignore_invite = inviteToken;
      }

      return $q((resolve, reject) =>
        updStore.dispatch(actions.user.emails(params)).then(reject, resolve)
      );
    };
  }
}
